<div class="rg-dialog-container" [ngClass]="detectDeviceService.isDesktop() ? 'desktop' : 'mobile'">
  <div class="dialog-header">
    <div class="icon-wrapper">
      <mat-icon svgIcon="shield-with-seven" class="shield-icon"></mat-icon>
    </div>
    <h2 class="dialog-title" i18n>Responsible Gaming Reminder</h2>
  </div>

  <div class="dialog-content">
    <div class="info-box">
      <div class="info-icon-wrapper">
        <mat-icon svgIcon="info" class="info-icon"></mat-icon>
      </div>
      <div class="info-text-wrapper">
        <p i18n>We encourage you to regularly review your gambling habits.</p>
        <p i18n>You can complete a voluntary self-assessment test to help evaluate your gaming behavior.</p>
        <p i18n>The test opens in new window on Gamblers Anonymous website.</p>
      </div>
    </div>
  </div>

  <div class="dialog-actions">
    <button round-button size="large" filled="filled" color="dark-secondary" class="remind-btn" (click)="onRemindLater()" i18n>Remind me later</button>
    <button round-button size="large" filled="filled" color="main" class="test-btn" (click)="onTakeTest()" i18n>Take test</button>
  </div>
</div>
